/*New Product Swatch Js*/
function handleEvent(t) {
    var n = t.closest('[data-product-options]');
    var elements = n.querySelectorAll('.t4s-pr-color__item');
    elements.forEach(function(element) {
        element.classList.remove("is-swatch--selected");
    });
    t.classList.add("is-swatch--selected");
    var o,
        a,
        p_id = t.getAttribute('data-pid'),
        img = t.getAttribute('data-img'),
        img_2 = t.getAttribute('data-img-2'),
        vid = t.getAttribute('data-vid'),
        Url = t.getAttribute('data-url'),
        price = t.getAttribute('data-price'),
        available = t.getAttribute('data-available'),
        soldOutElement = n.querySelector('.grid__item-image-wrapper'),
        pr_price = n.querySelector('.grid-product__price'),
        pr_img = n.querySelector('.grid__image-ratio img'),
        pr_img_2 = n.querySelector('.grid-product__secondary-image img'),
        pr_href = n.querySelector('.grid-product__link'),
        v_data = n.querySelector('.product-stone-color-options');

        if(p_id !=""){
            var soldOutElement = n.querySelector('.grid-product__link');
        }
        if(img != "" && pr_img){
            pr_img.srcset = img;
            pr_img.src = img;
        }
        if(img_2 != "" && pr_img_2){
            pr_img_2.srcset = img_2;
            pr_img_2.src = img_2;
        }
        if(Url != "" && pr_href){
            pr_href.href = Url;
        }
        if(price != "" && pr_price){
            pr_price.innerHTML = price;
        }
        if(vid != "" && v_data){
            v_data.style.display = "flex";
            v_data.querySelector('.num').innerHTML = vid;
        }
        if(vid == "" && v_data){
            v_data.style.display = "none";
        }
        if(available == "false" && soldOutElement){
            const htmlContent = '<div class="grid-product__tag grid-product__tag--sold-out">Sold Out</div>';
            const sold_tag = n.querySelector('.grid-product__tag--sold-out');
            if(sold_tag){
              n.querySelector('.grid-product__tag--sold-out').remove();
            }
            soldOutElement.insertAdjacentHTML('beforebegin', htmlContent);
        }
        if(available == "true"){
            const sold_tag = n.querySelector('.grid-product__tag--sold-out');
            if(sold_tag){
              n.querySelector('.grid-product__tag--sold-out').remove();
            }
        }
}
function handleSelectChange(selectElement) {
    var selectedValue = selectElement.value;
    window.location.href = selectedValue;
}

/*Accordian js*/
var acc = document.getElementsByClassName("tab-title");
var i;

for (i = 0; i < acc.length; i++) {	
    acc[i].onclick = function() {	
        var panel = this.nextElementSibling;
        var coursePanel = document.getElementsByClassName("tab-panel");
        var courseAccordion = document.getElementsByClassName("tab-title");
        var courseAccordionActive = document.getElementsByClassName("tab-title active");
    
        if (panel.style.maxHeight){
            panel.style.maxHeight = null;
    		this.classList.remove("active");
        } else {
            for (var ii = 0; ii < courseAccordionActive.length; ii++) {
                courseAccordionActive[ii].classList.remove("active");
            }
            for (var iii = 0; iii < coursePanel.length; iii++) {
                this.classList.remove("active");
                coursePanel[iii].style.maxHeight = null;
    		}  
            panel.style.maxHeight = panel.scrollHeight + "px"; 
            this.classList.add("active");
        } 
    }
}


/*Cart packaging Js*/
function toggleDivVisibility(value) {
    var toggleDivs = document.querySelectorAll('.attribute-item.toggleDiv');
    var elementDivs = document.querySelectorAll('.attribute-item.signature');
    if (value === 'Gift') {
        toggleDivs.forEach((toggleDiv) => {
            toggleDiv.style.display = 'block';
        });
        elementDivs.forEach((elementDiv) => {
            if (elementDiv) {
                elementDiv.classList.add("active-box");
            }
        });
    } else {
        toggleDivs.forEach((toggleDiv) => {
            toggleDiv.style.display = 'none';
            var myInput = toggleDiv.querySelector('.input-full');
            if(myInput){
              myInput.value = '';
            }
        });
        elementDivs.forEach((elementDiv) => {
            if (elementDiv.classList.contains("active-box")) {
                elementDiv.classList.remove("active-box");
            }
        });
    }
}

/*table top & bottom Scroll Code*/
function doubleScroll(element) {
    const scrollbar = document.createElement("div");
    scrollbar.appendChild(document.createElement("div"));
    scrollbar.style.overflow = "auto";
    scrollbar.style.overflowY = "hidden";
    scrollbar.classList.add("table-wrapper-scroll");
    scrollbar.firstChild.style.width = element.scrollWidth + "px";
    scrollbar.firstChild.style.paddingTop = "1px";
    scrollbar.firstChild.appendChild(document.createTextNode("\xA0"));
    let running = false;
    // Keep scrollbar in sync when element size changes
    new ResizeObserver(() => {
        scrollbar.firstChild.style.width = element.scrollWidth + "px";
    }).observe(element);
    scrollbar.onscroll = function () {
        if (running) {
            running = false;
            return;
        }
        running = true;
        element.scrollLeft = scrollbar.scrollLeft;
    };
    element.onscroll = function () {
        if (running) {
            running = false;
            return;
        }
        running = true;
        scrollbar.scrollLeft = element.scrollLeft;
    };
    element.parentNode.insertBefore(scrollbar, element);
}

document.addEventListener("DOMContentLoaded", () => {
    var tables = document.querySelectorAll('#doubleScroll .table-wrapper');
    tables.forEach((table) => {
        doubleScroll(table);            
    });

    const buttonRightS = document.querySelectorAll('.scroll-arrow button.right');
    const buttonLeftS = document.querySelectorAll('.scroll-arrow button.left');
    
    buttonRightS.forEach((buttonRight) => {
        buttonRight.onclick = function () {
            document.querySelector('#doubleScroll .table-wrapper').scrollLeft += 150;
        };
    });
    buttonLeftS.forEach((buttonLeft) => {
        buttonLeft.onclick = function () {
            document.querySelector('#doubleScroll .table-wrapper').scrollLeft -= 150;
        };
    });
});